<template>
    <el-form-item :label="$t.__('companysearch.FR_form.company_informations')" prop="search">
        <el-input
            id="search"
            v-model="form.search"
            :disabled="!providerEnabled"
            :class="{ 'w-5': inline }"
            :placeholder="$t.__('companysearch.FR_form.enter_company_informations')"
            @keyup.enter="$emit('search-companies')"
        />
    </el-form-item>
    <el-form-item v-if="useJobCode" :label="$t.__('common.labels.NAF_code')" prop="jobCode">
        <el-input
            id="jobCode"
            v-model="form.jobCode"
            :disabled="!providerEnabled"
            :placeholder="$t.__('companysearch.FR_form.enter_NAF_code')"
        ></el-input>
    </el-form-item>
    <el-form-item
        :label="$t.__('companysearch.FR_form.department')"
        prop="district"
        class="error-label-width-1"
    >
        <el-input
            id="district"
            v-model="form.district"
            :disabled="!providerEnabled"
            class="w-1"
            maxlength="3"
        />
    </el-form-item>
</template>
<script>
export default {
    props: {
        providerEnabled: {
            type: Boolean,
            required: true,
            default: true,
        },
        form: {
            type: Object,
            required: true,
            default: () => {},
        },
        useJobCode: {
            type: Boolean,
            required: true,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>
